import type { ReactNode } from 'react';

interface LegalLinkProps {
  /** The document's URL, or nothing on a deployment that has not named its legal pages. */
  href: string | undefined;
  children: ReactNode;
}

/** A word in a legal sentence that links to the document in a new tab, so the
 * form it sits under keeps its state. Without a URL the word stays plain text. */
export function LegalLink({ href, children }: LegalLinkProps) {
  if (!href) return <>{children}</>;
  return (
    <a href={href} target="_blank" rel="noreferrer" className="whitespace-nowrap text-ink underline underline-offset-2 hover:text-acc">
      {children}
    </a>
  );
}
